module.exports = __webpack_public_path__ + "img/girl_002_thumb.4e2b3556.jpg";